import { TwitterShareButton } from 'react-share';
import copyLinkFunction from 'components/Dashboard/utilities/copyLinkFunction';
import ModalComponent from 'components/Common/Modal';

const SentimentSharePopup = (props) => {
  const { url, title, showPopUp, setShowPopup } = props;
  return (
    <ModalComponent isOpen={showPopUp} setIsOpen={setShowPopup} additionalClass={'delete-keywordcategory-modal'}>
      <SentimentSharePopupContent url={url} title={title} />
    </ModalComponent>
  );
};

const SentimentSharePopupContent = (props) => {
  const { url, setShowPopup, title } = props;

  return (
    <div className='p-3 px-lg-5 py-5'>
      <h3 className='main-title'>Share</h3>
      <div className='d-flex justify-content-center px-4 pb-4 pt-2'>
        <div className='row stakeholder-share-buttons'>
          <button
            className='general-button position-relative p-3 copy-link-button'
            onClick={(e) => {
              copyLinkFunction({ e, url, closeFunction: () => setShowPopup(false) });
            }}
          >
            <span className='icon-share-image icon-share-image-copy'></span>
            <span>Copy link</span>
          </button>
          <TwitterShareButton
            url={url}
            title={title}
            onClick={() => {
              setShowPopup(false);
            }}
          >
            <span className='icon-share-image icon-share-image-twitter'></span>
            <span>Twitter</span>
          </TwitterShareButton>
        </div>
      </div>
    </div>
  );
};

export { copyLinkFunction };
export default SentimentSharePopup;
